import { Result } from 'antd';

export default ({ extraRender }) => (
  <Result
    status="403"
    title="403"
    subTitle="Sorry, looks you dont have access to this feaure, please contact the admin."
    extra={extraRender}
  />
);